import { supabase } from './supabase';

export async function logActivity(action: string, details: string) {
  try {
    const { error } = await supabase.rpc('log_activity', {
      p_action: action,
      p_details: details
    });

    if (error) throw error;
  } catch (error) {
    console.error('Error logging activity:', error);
  }
}